// ═══ 대표 링크 가입 업체 — 세션 user.malsoJoin 다시 읽기 (YK 대표 링크 2026-11-03) ═══
// 웹 세션 user 는 로그인 때 받은 값이라, 그 뒤 대행사가 거래처 연결을 해도 대기 안내가 남는다.
// 말소 홈·신청 화면 진입 때 malsoJoin 이 있으면 GET /users/me 를 한 번 읽어 값이 바뀌었을 때만
// 세션 저장 → 'company-switched'(App.js 가 user 교체 — moreActions.applyMalsoMode 와 같은 규약). 실패는 조용히 둔다.
import { getMe } from './api';

/// → Promise<boolean> (세션을 바꿨으면 true)
export function refreshMalsoJoin(user) {
  if (!user || !user.malsoJoin) return Promise.resolve(false);
  return getMe().then(function (me) {
    var nextJoin = (me && me.malsoJoin) || null;
    if (JSON.stringify(nextJoin) === JSON.stringify(user.malsoJoin)) return false;
    var next = null;
    try {
      var raw = window.sessionStorage.getItem('autodoc_user');
      next = Object.assign({}, raw ? JSON.parse(raw) : user, { malsoJoin: nextJoin });
      window.sessionStorage.setItem('autodoc_user', JSON.stringify(next));
    } catch (e) { next = Object.assign({}, user, { malsoJoin: nextJoin }); /* private mode — 이벤트로만 */ }
    try { window.dispatchEvent(new CustomEvent('company-switched', { detail: next })); } catch (e) { /* 구형 브라우저 */ }
    return true;
  }).catch(function () { return false; });
}
